import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import CountriesItemForm from "./CountriesItemForm";

const CountriesSubPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="country"
            modeApiName2="countries"
            ItemFormComponent={CountriesItemForm}
        />
    );
};

export default CountriesSubPage;